module.exports = __webpack_public_path__ + "static/img/A140.65b089f2.jpg";